
import VueHorizontal from "vue-horizontal";
/* eslint-disable */
export default {
  components: { VueHorizontal },
  data() {
    return {
      surveyId: null,
      survey: null,
      steps: {
        "osnovni-podaci": {
          name: this.$i18n.t("questionnaire.basicInfo"),
          questions: [],
        },
      },
      stepNames: [],
      currentStep: "osnovni-podaci",
      refreshKey: 0,
      backendData: {},
      errors: [],
      emailErr: null,
      phoneErr: null,
      left: 0,
      originX: 0,
      originLeft: 0,
      loading: false,
      consent: null,
      defaultInputs: [
        {
          id: 1,
          vModel: this.firstName,
          type: "text",
          label: this.$i18n.t("questionnaire.firstName"),
          labelFor: "firstName",
          error: "firstNameError",
          required: true,
          class: "col-span-12 md:col-span-6",
          component: "ui-input",
        },
        {
          id: 2,
          vModel: this.lastName,
          type: "text",
          label: this.$i18n.t("questionnaire.lastName"),
          labelFor: "lastName",
          error: "lastNameError",
          required: true,
          class: "col-span-12 md:col-span-6",
          component: "ui-input",
        },
        {
          id: 3,
          vModel: this.workplace,
          type: "text",
          label: this.$i18n.t("questionnaire.workplace"),
          labelFor: "workplace",
          error: "workplaceError",
          required: true,
          class: "col-span-12",
          component: "ui-input",
        },
        {
          id: 4,
          vModel: this.contactPhone,
          type: "tel",
          label: this.$i18n.t("questionnaire.contactPhone"),
          labelFor: "contactPhone",
          error: "contactPhoneError",
          required: true,
          class: "col-span-12 md:col-span-6",
          component: "ui-input",
        },
        {
          id: 5,
          vModel: this.contactEmail,
          type: "email",
          label: this.$i18n.t("questionnaire.contactEmail"),
          labelFor: "contactEmail",
          error: "contactEmailError",
          required: true,
          class: "col-span-12 md:col-span-6 input-mail-border",
          component: "ui-input",
        },
        {
          id: 6,
          vModel: this.companyName,
          type: "text",
          label: this.$i18n.t("questionnaire.companyName"),
          labelFor: "companyName",
          error: "companyNameError",
          required: true,
          class: "col-span-12",
          component: "ui-input",
        },
        {
          id: 7,
          vModel: this.oib,
          type: "text",
          label: this.$i18n.t("questionnaire.oib"),
          labelFor: "oib",
          error: "",
          required: false,
          class: "col-span-12 md:col-span-5",
          component: "ui-input",
        },
        {
          id: 8,
          vModel: this.address,
          type: "text",
          label: this.$i18n.t("questionnaire.address"),
          labelFor: "address",
          error: "",
          required: false,
          class: "col-span-12 md:col-span-7",
          component: "ui-input",
        },
      ],
    };
  },
  destroyed() {
    this.onMouseUp();
  },
  computed: {
    activeStep: function () {
      this.refreshKey;
      return this.steps[this.currentStep];
    },
  },
  watch: {
    async $isInEditMode(v) {
      if (!v && this.$refs.anketaid && this.$refs.anketaid.computedValue) {
        if (this.$refs.anketaid.computedValue.replace(/<\/?[^>]+(>|$)/g, "")) {
          this.surveyId = +this.$refs.anketaid.computedValue.replace(
            /<\/?[^>]+(>|$)/g,
            ""
          );
        }
        if (this.surveyId) {
          await this.getSurvey(this.surveyId);
        } else {
          this.$toast.error("Molimo unesite ID od ankete!");
        }
      }
    },
  },

  async mounted() {
    if (this.$refs.anketaid && this.$refs.anketaid.computedValue) {
      if (this.$refs.anketaid.computedValue.replace(/<\/?[^>]+(>|$)/g, "")) {
        this.surveyId = +this.$refs.anketaid.computedValue.replace(
          /<\/?[^>]+(>|$)/g,
          ""
        );
      }
    }
    if (this.surveyId) {
      await this.getSurvey(this.surveyId);
    } else {
      this.$toast.error("Molimo unesite ID od ankete!");
    }
  },
  methods: {
    async getSurvey(surveyId) {
      const stableVersion = "v1";
      const apiPrefix = "api";
      const marketingModulePrefix = "marketing";
      const urlObject = {
        apiUrl: "survey/public/get?id=" + surveyId,
        method: "get",
        modulePrefix: marketingModulePrefix,
        version: stableVersion,
      };
      const { version, modulePrefix, method, apiUrl } = urlObject;
      const url = `${apiPrefix}/${version}/${modulePrefix}/${apiUrl}`;
      try {
        this.loading = true;
        this.backendData = (await this.$axios[method](url)).data.data;
        this.loading = false;
        this.backendData.questions.forEach((question) => {
          const key = this.getValidKey(question.description);
          this.$set(this.steps, key, {});
          this.steps[key].questions = [];
          this.steps[key].name = question.description;
        });

        this.backendData.questions.forEach((question) => {
          const key = this.getValidKey(question.description);
          const component = this.getQuestionType(question.type);

          if (component === "questionnaire-input-text") {
            question.answers = [{ value: "" }];
          }

          this.steps[key].questions.push({
            component,
            id: question.id,
            title: question.question,
            type: question.type,
            answers: question.answers,
            dropdown: false,
          });
        });

        for (let key in this.steps) {
          this.stepNames.push(key);
        }
      } catch (e) {
        this.loading = false;
        console.log(e);
      }
    },
    getValidKey(key) {
      return key.replaceAll(" ", "-").toLowerCase();
    },
    getQuestionType(number) {
      if (!number) return;

      switch (number) {
        case 1:
          return "questionnaire-dropdown-single";
        case 2:
          return "questionnaire-dropdown-multiple";
        case 3:
          return "questionnaire-radio";
        case 6:
          return "questionnaire-input-text";
        case 7:
          return "questionnaire-input-text";
      }
    },

    setAnswer(question, answer) {
      const type = this.getQuestionType(question.type);

      if (
        type === "questionnaire-radio" ||
        type === "questionnaire-dropdown-single"
      ) {
        question.answers.forEach((answer) => (answer.value = false));
        this.$set(answer, "value", true);
      }

      if (type === "questionnaire-dropdown-multiple") {
        this.$set(answer, "value", !answer.value);
      }

      if (type === "questionnaire-input-text") {
        question.answers[0].value = answer;
      }

      this.refreshKey++;
    },
    async submit() {
      this.validateConsent();
      if (this.returnError("consentError")) return;

      var answers = [];

      // answered questions
      for (const key in this.steps) {
        const step = this.steps[key];

        step.questions.forEach((question) => {
          question.answers.forEach((answer) => {
            if (answer.value && answer.id)
              answers.push({ question: question.id, answer: answer.id });
            else if (answer.value && !answer.id)
              answers.push({ question: question.id, text: answer.value });
          });
        });
      }

      //unanswered questions
      var unansweredQ = [];
      var unansweredQuestionsForBackend = [];

      if (answers && answers.length) {
        unansweredQ = this.backendData.questions.filter(
          (question) =>
            !answers.map((answer) => answer.question).includes(question.id)
        );

        unansweredQ.forEach((question) => {
          if (question.typeString !== "text")
            unansweredQuestionsForBackend.push({
              question: question.id,
              answer: null,
            });
          else
            unansweredQuestionsForBackend.push({
              question: question.id,
              text: "",
            });
        });
      } else {
        this.backendData.questions.forEach((question) => {
          if (question.typeString !== "text")
            answers.push({ question: question.id, answer: null });
          else answers.push({ question: question.id, text: "" });
        });
      }

      // connect unanswered and answered questions
      answers = answers.concat(unansweredQuestionsForBackend);

      // push first step to array
      this.defaultInputs.forEach((input) => {
        answers.push({ question: input.id, text: input.vModel });
      });

      try {
        this.loading = true;
        const stableVersion = "v1";
        const apiPrefix = "api";
        const marketingModulePrefix = "marketing";
        const urlObject = {
          apiUrl: "survey/public/submit",
          method: "post",
          modulePrefix: marketingModulePrefix,
          version: stableVersion,
        };
        const { version, modulePrefix, method, apiUrl } = urlObject;
        const url = `${apiPrefix}/${version}/${modulePrefix}/${apiUrl}`;
        const res = await this.$axios.post(url, {
          answers,
          survey: this.surveyId,
          email: this.defaultInputs[4].vModel,
          firstName: this.defaultInputs[0].vModel,
          lastName: this.defaultInputs[1].vModel,
        });
        await this.createLead();
        this.loading = false;
        this.redirect();
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async createLead() {
      const obj = {
        customName: this.defaultInputs[0].vModel,
        customEmail: this.defaultInputs[4].vModel,

        status: 14,
        rating: null,
        category: 29,
        sourceType: 1,
        source: 80,
        products: [{ id: 44956, type: "product" }],
        productCategories: [],
        poi: "",
        process: null,
        tags: [],
        assignType: "person",
        owner: 231,
        notes: "",
        organisationAddress: "/",
        workplace: "/",
        recommendation: "/",
        email: this.defaultInputs[4].vModel,
        uid: null,
        customPhone: this.defaultInputs[3].vModel,
        address: null,
        propertyMedia: [],
        name: this.defaultInputs[5].vModel,
        industryType: null,
        nkdCode: null,
        annualBudget: null,
        numberOfEmployees: null,
        contactFirstName: this.defaultInputs[0].vModel,
        contactLastName: this.defaultInputs[1].vModel,
        contactPhone: this.defaultInputs[3].vModel,
        contactEmail: this.defaultInputs[4].vModel,
        contactPersonRole: null,
        vat: null,
        website: "",
        companyTags: [],
        media: [],
        companySubscribers: [
          { user: 234, role: 0 },
          { user: 280, role: 0 },
          { user: 231, role: 0 },
        ],
        qualifyReason: "",
        qualifiedReasons: [],
        nonqualifyReason: "",
        nonqualifiedReasons: [],
      };

      await this.$axios({
        url: "/api/v1/lead/company/create/web",
        method: "POST",
        data: { ...obj },
      })
        .then((res) => {})
        .catch((err) => {
          console.log(err);
        });
    },
    validateInfoAnswers() {
      if (!this.defaultInputs[0].vModel) {
        this.errors.push("firstNameError");
      } else this.errors = this.errors.filter((e) => e !== "firstNameError");

      if (!this.defaultInputs[1].vModel) {
        this.errors.push("lastNameError");
      } else this.errors = this.errors.filter((e) => e !== "lastNameError");
      if (!this.defaultInputs[2].vModel) {
        this.errors.push("workplaceError");
      } else this.errors = this.errors.filter((e) => e !== "workplaceError");

      if (!this.defaultInputs[3].vModel) {
        this.errors.push("contactPhoneError");
      } else if (
        this.defaultInputs[3].vModel &&
        !/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/im.test(
          this.defaultInputs[3].vModel
        )
      ) {
        this.errors.push("contactPhoneError");
        this.phoneErr = true;
      } else this.errors = this.errors.filter((e) => e !== "contactPhoneError");

      if (
        this.defaultInputs[4].vModel &&
        this.defaultInputs[4].vModel.length &&
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
          this.defaultInputs[4].vModel
        )
      ) {
        this.emailErr = false;
      } else if (
        this.defaultInputs[4].vModel &&
        this.defaultInputs[4].vModel.length &&
        !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
          this.defaultInputs[4].vModel
        )
      ) {
        this.emailErr = true;
      } else if (!this.defaultInputs[4].vModel) {
        this.emailErr = false;
      }
      if (!this.defaultInputs[4].vModel || this.emailErr) {
        this.errors.push("contactEmailError");
      } else this.errors = this.errors.filter((e) => e !== "contactEmailError");

      if (!this.defaultInputs[5].vModel) {
        this.errors.push("companyNameError");
      } else this.errors = this.errors.filter((e) => e !== "companyNameError");
    },
    validateConsent() {
      if (!this.consent) {
        this.errors.push("consentError");
        this.$toast.error(this.$i18n.t("questionnaire.consentError"));
      } else this.errors = this.errors.filter((e) => e !== "consentError");
    },
    returnError(id) {
      return !!(this.errors.length && this.errors.includes(id));
    },
    goToStep(key) {
      this.validateInfoAnswers();

      if (!this.errors.length) {
        this.currentStep = key;
      }

      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
    },
    goToNextStep() {
      this.validateInfoAnswers();

      if (this.errors.length) return;
      const currentIndex = this.stepNames.indexOf(this.currentStep);
      if (currentIndex >= this.stepNames.length - 1) return;
      this.currentStep = this.stepNames[currentIndex + 1];

      const i = this.stepNames.indexOf(this.currentStep);
      this.$refs.horizontal.scrollToIndex(i);

      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
    },
    goToPrevStep() {
      const currentIndex = this.stepNames.indexOf(this.currentStep);
      this.currentStep = this.stepNames[currentIndex - 1];

      const i = this.stepNames.indexOf(this.currentStep);
      this.$refs.horizontal.scrollToIndex(i);

      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
    },
    goBack() {
      history.back();
    },
    onScroll({ left }) {
      this.left = left;
    },
    onMouseDown(e) {
      this.originX = e.pageX;
      this.originLeft = this.left;

      window.addEventListener("mouseup", this.onMouseUp);
      window.addEventListener("mousemove", this.onMouseMove);
    },
    onMouseUp() {
      window.removeEventListener("mouseup", this.onMouseUp);
      window.removeEventListener("mousemove", this.onMouseMove);
    },
    onMouseMove(e) {
      const offset = e.pageX - this.originX;
      const left = this.originLeft - offset;

      this.$refs.horizontal.scrollToLeft(left, "auto");
    },
    async redirect() {
      if (this.$i18n.locale === "hr") {
        this.$router.push({
          path: "uspjeh",
        });
      } else {
        this.$router.push({
          path: "/success",
        });
      }
    },
    toggleDropdowns(index, e) {
      const target = e.target.classList.contains("dropdown-class");
      const targetAnswer = e.target.classList.contains("answer-class");

      this.activeStep.questions.forEach((question, i) => {
        if (i === index) {
          if (targetAnswer) {
            question.dropdown = false;
            return;
          }

          if (question.dropdown && !target) return;
          else if (question.dropdown && target) question.dropdown = false;
          else question.dropdown = true;
        } else {
          question.dropdown = false;
        }
      });
      this.refreshKey++;
    },
  },
};
